import type { ProductPickerField, ProductRef } from '@aquilixshop/ui-react';
import { FieldRow } from '../FieldRow';
import { EntityPickerListbox } from './EntityPickerListbox';
import { productPickerSource } from '../../lib/catalogApi';
import { bt } from '../../i18n';

/**
 * Product picker (feature 0023 P1) — the seller picks a REAL product for a section that references one
 * (`featured-product`, `related-products`, `collage`, an add-to-cart image…). Replaces the M4 stub with
 * a searchable listbox over `GET /api/products`. The stored value is the final `{ kind:'product', id }`
 * {@link ProductRef} (no migration); "None" clears it to `undefined`. Commits immediately.
 */
export function ProductControl({
  field,
  value,
  onChange,
}: {
  field: ProductPickerField;
  value: ProductRef | undefined;
  onChange: (next: ProductRef | undefined) => void;
}) {
  return (
    <FieldRow id={field.id} label={field.label} info={field.info} labelAs="span" layout="row">
      <EntityPickerListbox
        value={value?.id}
        onSelect={(id) => onChange(id ? { kind: 'product', id } : undefined)}
        source={productPickerSource}
        label={field.label}
        noneLabel={bt('chrome.common.none', 'None')}
        searchPlaceholder={bt('chrome.link.search_products', 'Search products…')}
        emptyLabel={bt('chrome.link.no_products', 'No products found.')}
        errorLabel={bt('chrome.link.products_failed', 'Couldn’t load products.')}
      />
    </FieldRow>
  );
}
